var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.52,
    height: 27.309,
    viewBox: "0 0 17.52 27.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-171.952 -642.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.713,670.089a.846.846,0,0,0,.724-.412c.328-.554,8.034-13.585,8.034-18.138a8.76,8.76,0,0,0-17.52,0c0,4.553,7.709,17.584,8.036,18.138A.844.844,0,0,0,180.713,670.089Zm0-25.625a7.084,7.084,0,0,1,7.075,7.075c0,3.068-4.587,11.7-7.075,16.036-2.49-4.337-7.077-12.969-7.077-16.036A7.086,7.086,0,0,1,180.713,644.464Z",
    transform: "translate(0 0)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.056,649.3a4.583,4.583,0,1,0-4.583,4.587A4.589,4.589,0,0,0,183.056,649.3Zm-4.583,2.9a2.9,2.9,0,1,1,2.9-2.9A2.9,2.9,0,0,1,178.473,652.2Z",
    transform: "translate(2.24 2.239)",
    fill: "#000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.ba2b7c1d603d362c438ab5b1b09b6147.svg";
export { ForwardRef as ReactComponent };